// src/hooks/banks/useForceDeleteAllBanks.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllBanks } from "../../api/apiBanks";
import { useTranslation } from "react-i18next";

function useForceDeleteAllBanks() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const { mutate: forceDeleteAllBanksMutation, isPending: isForceDeleteAll } = useMutation({
        mutationFn: forceDeleteAllBanks,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["banks"] });
            toast.success(isArabic ? "تم حذف البنوك المحددة نهائياً" : "Selected banks permanently deleted");
        },
        onError: (err) => {
            toast.error(err?.message || (isArabic ? "فشل في الحذف النهائي" : "Failed to force delete banks"));
        },
    });

    return { forceDeleteAllBanks: forceDeleteAllBanksMutation, isForceDeleteAll };
}

export default useForceDeleteAllBanks;
